"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    useRealTimeAudioRecorder: ()=>useRealTimeAudioRecorder
});
const external_react_namespaceObject = require("react");
const audio_js_namespaceObject = require("../utils/audio.js");
function useRealTimeAudioRecorder(onAudioChunk, analytics) {
    const [isRecording, setIsRecording] = (0, external_react_namespaceObject.useState)(false);
    const [isMuted, setIsMuted] = (0, external_react_namespaceObject.useState)(false);
    const mediaStreamRef = (0, external_react_namespaceObject.useRef)(null);
    const audioTrackRef = (0, external_react_namespaceObject.useRef)(null);
    const audioContextRef = (0, external_react_namespaceObject.useRef)(null);
    const processorRef = (0, external_react_namespaceObject.useRef)(null);
    const startRecording = (0, external_react_namespaceObject.useCallback)(async ()=>{
        if (isRecording) return;
        if (audioContextRef.current) try {
            await audioContextRef.current.close();
            audioContextRef.current = null;
        } catch (err) {
            analytics.logError({
                loggedFrom: 'useRealTimeAudioRecorder.startRecording.cleanup',
                message: 'Error closing previous AudioContext',
                error: err instanceof Error ? err.message : String(err)
            });
        }
        try {
            const stream = await navigator.mediaDevices.getUserMedia({
                audio: {
                    noiseSuppression: true,
                    echoCancellation: true
                }
            });
            mediaStreamRef.current = stream;
            const track = stream.getAudioTracks()[0];
            audioTrackRef.current = track;
            const audioContext = new AudioContext({
                sampleRate: 24000
            });
            const mediaStreamSource = audioContext.createMediaStreamSource(stream);
            const highPassFilter = audioContext.createBiquadFilter();
            highPassFilter.type = 'highpass';
            highPassFilter.frequency.value = 200;
            const lowPassFilter = audioContext.createBiquadFilter();
            lowPassFilter.type = 'lowpass';
            lowPassFilter.frequency.value = 4350;
            mediaStreamSource.connect(highPassFilter);
            highPassFilter.connect(lowPassFilter);
            const processorCode = `
        class MyAudioProcessor extends AudioWorkletProcessor {
          constructor() {
            super();
            this.shouldProcess = true;

            this.port.onmessage = (event) => {
              if (event.data.type === 'terminate') {
                this.shouldProcess = false;
              }
            };
          }

          process(inputs, outputs, parameters) {
            if (!this.shouldProcess) {
              return false;
            }
            const input = inputs[0];
            if (input && input.length > 0) {
              const channelData = input[0];
              this.port.postMessage(channelData.slice());
            }
            return true;
          }
        }
        registerProcessor('my-audio-processor', MyAudioProcessor);
      `;
            const blob = new Blob([
                processorCode
            ], {
                type: "application/javascript"
            });
            const url = URL.createObjectURL(blob);
            await audioContext.audioWorklet.addModule(url);
            const processorNode = new AudioWorkletNode(audioContext, 'my-audio-processor');
            lowPassFilter.connect(processorNode);
            processorNode.connect(audioContext.destination);
            processorNode.port.onmessage = (event)=>{
                if (!audioTrackRef.current?.enabled) return;
                const float32Array = event.data;
                const pcm16Array = (0, audio_js_namespaceObject.floatTo16BitPCM)(float32Array);
                const base64String = (0, audio_js_namespaceObject.convertPCM16ToBase64)(pcm16Array);
                onAudioChunk(base64String);
            };
            processorRef.current = processorNode;
            audioContextRef.current = audioContext;
            setIsRecording(true);
        } catch (error) {
            analytics.logError({
                loggedFrom: 'useRealTimeAudioRecorder.startRecording',
                message: 'Failed to start recording user audio',
                error: error instanceof Error ? error.message : String(error)
            });
            throw error;
        }
    }, [
        isRecording,
        onAudioChunk,
        analytics
    ]);
    const stopRecording = (0, external_react_namespaceObject.useCallback)(()=>{
        setIsMuted(false);
        if (processorRef.current) {
            processorRef.current.port.postMessage({
                type: 'terminate'
            });
            processorRef.current.disconnect();
            processorRef.current = null;
        }
        if (audioContextRef.current) {
            audioContextRef.current.close()?.catch(console.error);
            audioContextRef.current = null;
        }
        if (audioTrackRef.current) {
            audioTrackRef.current.stop();
            audioTrackRef.current = null;
        }
        if (mediaStreamRef.current) {
            mediaStreamRef.current.getTracks().forEach((track)=>track.stop());
            mediaStreamRef.current = null;
        }
        setIsRecording(false);
    }, []);
    const toggleMute = (0, external_react_namespaceObject.useCallback)(()=>{
        if (audioTrackRef.current) {
            const newMuteState = !isMuted;
            audioTrackRef.current.enabled = !newMuteState;
            setIsMuted(newMuteState);
        }
    }, [
        isMuted
    ]);
    (0, external_react_namespaceObject.useEffect)(()=>()=>{
            if (isRecording) stopRecording();
        }, [
        isRecording,
        stopRecording
    ]);
    return {
        isRecording,
        isMuted,
        audioTrack: audioTrackRef.current,
        mediaStream: mediaStreamRef.current,
        audioContext: audioContextRef.current,
        startRecording,
        stopRecording,
        toggleMute
    };
}
exports.useRealTimeAudioRecorder = __webpack_exports__.useRealTimeAudioRecorder;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "useRealTimeAudioRecorder"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
